<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-peaceful-reality">
<h1>The Peaceful Reality</h1>
<p style="text-indent:0px;">We all crave peace,</p>
<p style="text-indent:0px;">Though all around is war.</p>
<p style="text-indent:0px;">Will it ever cease?</p>
<p style="text-indent:0px;">Will there be nothing to adore?</p><br/>
<p style="text-indent:0px;">Bombs exploding relentless,</p>
<p style="text-indent:0px;">Tearing our Earth apart.</p>
<p style="text-indent:0px;">Children dying? Senseless!</p>
<p style="text-indent:0px;">We need a fresh start.</p><br/>
<p style="text-indent:0px;">Poverty-stricken nations,</p>
<p style="text-indent:0px;">They should not exist.</p>
<p style="text-indent:0px;">Immigrants fill police stations,</p>
<p style="text-indent:0px;">Too broken to protest.</p><br/>
<p style="text-indent:0px;">Hunger, disease and terrorism,</p>
<p style="text-indent:0px;">Are our wage-paying enemy.</p>
<p style="text-indent:0px;">We can easily defeat them,</p>
<p style="text-indent:0px;">But they drive the economy!</p><br/>
<p style="text-indent:0px;">Behind the scenes of politics,</p>
<p style="text-indent:0px;">Suit people without remorse.</p>
<p style="text-indent:0px;">They got the world in this fix,</p>
<p style="text-indent:0px;">They deny this, oh but of course.</p><br/>
<p style="text-indent:0px;">We all have equal rights,</p>
<p style="text-indent:0px;">The Earth spins to nature’s call.</p>
<p style="text-indent:0px;">There will continue to be fights,</p>
<p style="text-indent:0px;">Until there is nothing left at all.</p><br/>
<p style="text-indent:0px;">We will be an extinct species,</p>
<p style="text-indent:0px;">And maybe rightly so.</p>
<p style="text-indent:0px;">Maybe living back in teepees?</p>
<p style="text-indent:0px;">Probably a better life though.</p><br/>
<p style="text-indent:0px;">All of our scientific advances,</p>
<p style="text-indent:0px;">Or a technological miracle,</p>
<p style="text-indent:0px;">Mean nothing to the masses,</p>
<p style="text-indent:0px;">If we keep being cynical.</p><br/>
<p style="text-indent:0px;">A mountain with a stream,</p>
<p style="text-indent:0px;">A field filled with wildlife.</p>
<p style="text-indent:0px;">One day they will be a dream,</p>
<p style="text-indent:0px;">In nuclear afterlife.</p><br/>
<p style="text-indent:0px;">It may not be too late,</p>
<p style="text-indent:0px;">Though difficult to conceive of.</p>
<p style="text-indent:0px;">Earth is in an appalling state,</p>
<p style="text-indent:0px;">Our only hope is love!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch015.vue?1b5b7911